import React from "react";
import { useI18n } from "../domain/i18n";
import { NewsItem } from "../domain/news";
import { CoverImage } from "./CoverImage";

export function ArticleTeaser({ item }: { item: NewsItem }) {
  const I18n = useI18n();
  return (
    <article className="teaser">
      {item.teaser_image_path && (
        <div className="teaser__image">
          <a href={item.path}>
            <CoverImage url={item.teaser_image_path} />
          </a>
        </div>
      )}

      <h2 className="teaser__title">
        <a href={item.path}>{item.title}</a>
      </h2>

      <div className="teaser__content" dangerouslySetInnerHTML={{ __html: item.abstract }} />

      <a className="teaser__details-link" href={item.path}>
        {I18n.t("articles.read-more")}
      </a>
    </article>
  );
}
